import React from "react";

export default function DashboardRow({ children, style }) {
	return (
	       <div style={{
	           display: "flex",
	           width: "100%",
	           gap: "20px",
	           minHeight: 0,   // 🔥 critical for flex layouts
	           ...style
	       }}>
	           {children}
	       </div>
	   );
}